import { DateTime } from 'luxon';
import { PaymentApiResponse } from '../../api/BillingApi';
import { CurrencyCode } from '../../config/CurrencyCode';

export enum PaymentType {
  PAYMENT = 'payment', REFUND = 'refund',
}

export class Payment {
  id: number;
  type: PaymentType;
  created: DateTime;
  currency: CurrencyCode;
  receiptUrl: string;
  saleGross: number;
  quantity: number;

  static fromApi(apiData: PaymentApiResponse): Payment {
    const pay = new Payment();

    pay.id = apiData.id;
    pay.created = DateTime.fromISO(apiData.created, { zone: 'utc' });
    pay.currency = apiData.currency as CurrencyCode;
    pay.receiptUrl = apiData.receiptUrl;
    pay.saleGross = apiData.saleGross;
    pay.quantity = apiData.quantity;
    pay.type = apiData.type as PaymentType;

    return pay;
  }
}
